import { NativeStorage } from '@ionic-native/native-storage'
import { isPlatform } from '@ionic/core'

export const getItem = async (key: string): Promise<string | null> => {
  if (isPlatform('capacitor')) {
    try {
      return (await NativeStorage.getItem(key)) || null
    } catch (e) {
      console.error('failed to get key', key, e)
      return null
    }
  }

  return localStorage.getItem(key) || null
}

export const hasItem = async (key: string): Promise<boolean> => {
  return !!await getItem(key)
}

export const setItem = async (key: string, item: string): Promise<void> => {
  if (isPlatform('capacitor')) {
    console.log('try to write value', item)
    try {
      await NativeStorage.setItem(key, item)
    } catch (e) {
      console.error('failed to write key', key, e)
    }

    return
  }

  localStorage.setItem(key, item)
}

export const removeItem = async (key: string): Promise<void> => {
  if (isPlatform('capacitor')) {
    try {
      await NativeStorage.remove(key)
    } catch (e) {
      console.error('could not remove key', key, e)
    }

    return
  }

  localStorage.removeItem(key)
}
